/* Shoden-Technik 2026-09-10: consume Motion's existing cart markup.
   Observe only the product container; never the shipping indicator we update.
   No independent requests, polling, cart mutations or tracking events. */
(function () {
  'use strict';
  function init() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    const products = drawer.querySelector('[data-products]');
    const bar = drawer.querySelector('[data-free-shipping]');
    if (!products || !bar) return;
    const text = bar.querySelector('.free-shipping-text');
    const fill = bar.querySelector('.cart-thresholds__bar-main');
    const icon = bar.querySelector('.cart-thresholds__icon');
    if (!text || !fill) return;
    function updateBar() {
      const source = products.querySelector('[data-free-shipping-source]');
      if (!source) return;
      const remaining = Number(source.dataset.remaining);
      const progress = Number(source.dataset.progress);
      const money = source.dataset.remainingMoney;
      if (!Number.isFinite(remaining) || !Number.isFinite(progress) || !money) return;
      const label = remaining <= 0
        ? '🎉 Kostenloser Versand!'
        : `Nur noch ${money} bis zum kostenlosen Versand!`;
      const width = (remaining <= 0 ? 100 : Math.max(0, Math.min(100, progress))) + '%';
      // Avoid repeated aria-live announcements when the cart total did not change.
      if (text.textContent !== label) text.textContent = label;
      if (fill.style.width !== width) fill.style.width = width;
      if (icon && icon.style.left !== width) icon.style.left = width;
    }
    new MutationObserver(updateBar).observe(products, { childList: true, subtree: true });
    // The custom trash button edits item DOM directly instead of rebuilding it.
    // Ask the existing Motion controller for one normal rebuild after that action.
    document.addEventListener('custom:cart-item-removed', function () {
      document.dispatchEvent(new CustomEvent('cart:build'));
    });
    updateBar();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
